<div
  class="fw-bold bg-white p-3 rounded-5 mb-5 container mt-5"
  *ngIf="permissionsService.createPermission"
>
  <!-- Primera fila -->
  <div class="d-flex justify-content-between">
    <div>
      <label for="information" class="labelInformation">{{
        information
      }}</label>
    </div>
  </div>

  <div class="container mt-5">
    <ckeditor
      [editor]="Editor"
      [config]="editorConfig"
      [(ngModel)]="htmlContent"
    ></ckeditor>
  </div>

  <!-- Cuarta fila -->
  <div class="row mt-3">
    <div class="col text-end">
      <button
        class="btn btn-primary w-100 w-md-auto"
        (click)="createNotification(true)"
      >
        Save Notification
      </button>
    </div>
  </div>
</div>

<div class="container mt-5">
    <div class="accordion accordion-flush" id="accordionExample">
      <div class="accordion-item">
        <div class="d-flex justify-content-between align-items-center">
          <h2 class="accordion-header flex-grow-1" id="headingOne">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseOne"
              aria-expanded="true"
              aria-controls="collapseOne"
              style="font-weight: bold; font-size: 1.5rem"
            >
              Announcements
            </button>
          </h2>
  
          <!-- Switch al lado del botón de desplegar -->
          <div *ngIf="status === 0 || status === 1" class="form-check form-switch me-3">
            <input
              class="form-check-input"
              type="checkbox"
              [(ngModel)]="status"
              id="flexSwitchCheckDefault"
              [checked]="status === 1"
              [disabled]="!permissionsService.editPermission"
              (change)="toggleStatus($event)"
              data-bs-toggle="modal"
              data-bs-target="#modalSwitch"
            />
          </div>
          <div *ngIf="status === 2">
            <span class="archived">Archived</span>
          </div>
        </div>
  
        <!-- Contenido colapsable -->
        <div
          id="collapseOne"
          class="accordion-collapse collapse show"
          aria-labelledby="headingOne"
          data-bs-parent="#accordionExample"
        >
          <div class="accordion-body">
            <div [innerHTML]="sanitizedHtmlContent"></div>
          </div>
        </div>
      </div>
    </div>
  </div>


  <!-- Modal -->
<div
class="modal fade"
id="modalSwitch"
tabindex="-1"
aria-labelledby="exampleModalLabel"
aria-hidden="true"
>
<div class="d-flex align-items-center justify-content-center full-height">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5
          class="modal-title"
          id="exampleModalLabel"
          style="font-weight: bold"
        >
          Notification Active/Inactive
        </h5>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
          (click)="createNotification(false)"
        ></button>
      </div>
      <div class="modal-body">
        Are you sure you want to Activate/Deactivate this notification?
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-secondary"
          data-bs-dismiss="modal"
          (click)="createNotification(false)"
        >
          Close
        </button>
        <button
          type="button"
          class="btn btn-primary"
          data-bs-dismiss="modal"
          (click)="createNotification(true)"
        >
          Yes, Activate/Desactivate
        </button>
      </div>
    </div>
  </div>
</div>
</div>